// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3XYBl","fileBtn":"File_fileBtn__1AQ6n","closeBtn":"File_closeBtn__drGPE","fileSelected":"File_fileSelected__Rf0dS","disabled":"File_disabled__2itmR"};